/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MonitEntityTechOrderBy = {
    Asset: 'asset',
    SourceAsset: 'source_asset',
    Port: 'port',
    TechName: 'tech_name',
    Shared: 'shared',
    Found: 'found',
    Created: 'created',
    Updated: 'updated',
    Version: 'version'
} as const;
export type MonitEntityTechOrderBy = typeof MonitEntityTechOrderBy[keyof typeof MonitEntityTechOrderBy];


export function MonitEntityTechOrderByFromJSON(json: any): MonitEntityTechOrderBy {
    return MonitEntityTechOrderByFromJSONTyped(json, false);
}

export function MonitEntityTechOrderByFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityTechOrderBy {
    return json as MonitEntityTechOrderBy;
}

export function MonitEntityTechOrderByToJSON(value?: MonitEntityTechOrderBy | null): any {
    return value as any;
}

